import { render, staticRenderFns } from "./Album.vue?vue&type=template&id=0d5e53f3&scoped=true&"
import script from "./Album.vue?vue&type=script&lang=js&"
export * from "./Album.vue?vue&type=script&lang=js&"
import style0 from "./Album.vue?vue&type=style&index=0&id=0d5e53f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5e53f3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VImg,VRow})
